import React from 'react';
import { StatisticsTable } from './StatisticsTable';
import { StatisticsChart } from './StatisticsChart';
import { UserProductConsumptionStat } from '../../hooks/admin/useStatistics';

interface UserProductConsumptionSectionProps {
  userProductConsumptionStats: UserProductConsumptionStat[];
}

const UserProductConsumptionSection: React.FC<UserProductConsumptionSectionProps> = ({ 
  userProductConsumptionStats 
}) => {
  // Group by user and find most consumed product
  const userMap: Record<number, UserProductConsumptionStat[]> = {};
  
  userProductConsumptionStats.forEach((row) => {
    if (!userMap[row.user_id]) userMap[row.user_id] = [];
    userMap[row.user_id].push(row);
  });
  
  // Find the most consumed product for each user
  const userRows = Object.values(userMap).map((rows) => {
    const max = rows.reduce((prev, curr) =>
      curr.total_quantity > prev.total_quantity ? curr : prev
    , rows[0]);
    return { user: max, all: rows };
  });

  // Prepare data for table
  const tableData = userRows.map(({ user }) => ({
    id: user.user_id,
    user_name: user.user_name,
    user_surname: user.user_surname,
    product_name: user.product_name,
    total_quantity: user.total_quantity,
    total_spent: user.total_spent,
  }));

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
      <div className="bg-white rounded-2xl shadow-lg p-6 flex flex-col h-[370px]">
        <h3 className="font-bold text-lg mb-4 text-gray-800">En Çok Tüketilen Ürünler</h3>
        <div className="flex-1 overflow-auto">
          <StatisticsTable
            columns={[
              { key: 'user_name', label: 'Ad' },
              { key: 'user_surname', label: 'Soyad' },
              { key: 'product_name', label: 'En Çok Tükettiği Ürün' },
              { key: 'total_quantity', label: 'Toplam Miktar' },
              { key: 'total_spent', label: 'Toplam Harcama', render: row => `₺${row.total_spent.toFixed(2)}` },
            ]}
            data={tableData}
          />
        </div>
      </div>
      
      <div className="bg-white rounded-2xl shadow-lg p-6 flex flex-col h-[370px]">
        <h3 className="font-bold text-lg mb-4 text-gray-800">En Çok Ürün Tüketen Kullanıcılar (Bar Chart)</h3>
        <div className="flex-1 flex items-center justify-center min-h-0 w-full overflow-hidden">
          <StatisticsChart
            type="bar"
            data={tableData}
            dataKey="total_quantity"
            xKey="user_name"
            title=""
            color="#f472b6"
            height={260}
          />
        </div>
      </div>
    </div>
  );
};

export default UserProductConsumptionSection; 